var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6757 4H8.32432C7.17744 4 6.07753 4.45802 5.26656 5.27331C4.4556 6.0886 4 7.19436 4 8.34735V23.7804C4 24.9334 4.4556 26.0392 5.26656 26.8545C6.07753 27.6698 7.17744 28.1278 8.32432 28.1278H23.6757C24.8226 28.1278 25.9225 27.6698 26.7334 26.8545C27.5444 26.0392 28 24.9334 28 23.7804V8.34735C28 7.19436 27.5444 6.0886 26.7334 5.27331C25.9225 4.45802 24.8226 4 23.6757 4ZM25.8378 8.34735V18.9984H17.0811V6.17368H23.6757C24.2491 6.17368 24.7991 6.40269 25.2046 6.81033C25.61 7.21797 25.8378 7.77086 25.8378 8.34735ZM8.32432 6.17368H14.9189V10.9558H6.16216V8.34735C6.16216 7.77086 6.38996 7.21797 6.79544 6.81033C7.20093 6.40269 7.75088 6.17368 8.32432 6.17368ZM6.16216 23.7804V13.1294H14.9189V25.9541H8.32432C7.75088 25.9541 7.20093 25.7251 6.79544 25.3175C6.38996 24.9098 6.16216 24.3569 6.16216 23.7804ZM23.6757 25.9541H17.0811V21.172H25.8378V23.7804C25.8378 24.0659 25.7819 24.3486 25.6733 24.6123C25.5646 24.876 25.4053 25.1156 25.2046 25.3175C25.0038 25.5193 24.7654 25.6794 24.5031 25.7887C24.2408 25.8979 23.9596 25.9541 23.6757 25.9541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.9265fa71d5243256b3317419892ba85c.svg";
export { ForwardRef as ReactComponent };